<template>
    <div class="column-layout">
        <el-tabs v-model="activeName">
            <el-tab-pane label="设置服务能力" name="setEngineerServc">
                <swb-query-sort-area class="mb10" ref="query_model" :config="queryConfig" :queryOnLoad="false" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
                <div class="table-layout">
                    <el-table :data="ssuList" ref="ssuList" border style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" type="selection" width="55"></el-table-column>
                        <el-table-column prop="servcName" label="服务名称" align="left"></el-table-column>
                        <el-table-column label="服务项目名称" width="200" align="left">
                            <template slot-scope="rows">
                                <span>{{rows.row.title}}</span>
                                <div v-if="rows.row.srcMerchantId != null" class="table-tips"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务来源" width="150" align="left">
                            <template slot-scope="rows">
                                <span v-if="rows.row.srcMerchantType == 2">厂家授权</span>
                                <span v-else-if="rows.row.srcMerchantType == 4">承包授权</span>
                                <span v-else>自营</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务类型" align="left" width="150" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{servcTypeMap[rows.row.type]}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务用途" width="100" align="left">
                            <template slot-scope="rows">
                                <span>{{rows.row.comnOnlyFlag ? '常规服务' : '维保服务'}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="toDoorFee" label="上门费(元)" align="right" width="100">
                            <template slot-scope="rows">
                                <span>{{(rows.row.toDoorFee || 0).toFixed(2)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="workHourFee" label="参考人工费(元)" align="right" width="100">
                            <template slot-scope="rows">
                                <span>{{(rows.row.workHourFee || 0).toFixed(2)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="generallFee" label="服务费(元)" align="right" width="100">
                            <template slot-scope="rows">
                                <span>{{(rows.row.generallFee || 0).toFixed(2)}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="block pagination-layout">
                    <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                                   layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="复制服务能力" name="copyEngineerServc">
                <swb-servicer-engineer-list-for-select v-if="servicerShopId != null" :onlyShowAll="true" :servicerShopId="servicerShopId" :ssuIdList="[]" ref="swb_servicer_engineer_list_select"></swb-servicer-engineer-list-for-select>
                <swb-servicer-xngineer-list-for-select v-if="servicerShopId == null" ref="swb_servicer_xngineer_list_select"></swb-servicer-xngineer-list-for-select>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'

    import servcApi from '../../api/servc'
    import servcCategApi from '../../api/servcCateg'

    import SwbServicerXngineerListForSelect from '../orgStruct/ServicerXngineerListForSelect';
    Vue.regist(SwbServicerXngineerListForSelect);

    let configData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "服务名称",
            "code": "servcName",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "服务项目名称",
            "code": "title",
            "basic": true
        }, {
            "type": "Select",
            "label": "服务来源",
            "code": "srcMerchantType",
            "valueType": 'Integer',
            "basic": true,
            "dataList": [{
                "value": null,
                "label": '全部'
            }, {
                "value": "2",
                "label": "厂家授权"
            }, {
                "value": "4",
                "label": "承包授权"
            }, {
                "value": "0",
                "label": "自营"
            }],
        }, {
            "code": "type",
            "label": "服务类型",
            "type": "Select",
            "valueType": "Integer",
            "value": null,
            "basic": true,
            "hidden": false,
            "rptUsed": false,
            "ctxBindName": null,
            "dataList": []
        }, {
            "code": "comnOnlyFlag",
            "label": "服务用途",
            "type": "Select",
            "valueType": "Boolean",
            "value": null,
            "basic": false,
            "hidden": false,
            "rptUsed": false,
            "ctxBindName": null,
            "dataList": [
                {
                    "label": "- 全部 -",
                    "value": null
                },
                {
                    "label": "常规服务",
                    "value": "true"
                },
                {
                    "label": "维保服务",
                    "value": "false"
                }
            ]
        }],
        "sortFields": []
    };

    //
    export default {
        name: 'swb-engineer-ssu-list-for-select',
        desc: 'ssu多选',
        props: ['checkedIds', "servicerShopId"],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryConfig: configData,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                activeName: "setEngineerServc",
                //
                ssuList: [],
                loadingStaff: false,
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'ssuList',
                checkedList: [],
                servcTypeMap: {},
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.servcTypeMap = getEnumMap('servcType', 'value2text');
            //
            let self = this;
            self.checkedIdsX = self.checkedIds.clone();
            self.checkedIdsX.forEach(function (id) {
                let ssu = {};
                ssu.ssuId = id;
                self.checkedList.add(ssu);
            });
            this.getSsuList();
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                self.getServcTypeList(function (typeList) {
                    let servcTypeList = [{
                        value: null,
                        label: '- 全部 -'
                    }];
                    let servcTypes = getEnumList("servcType");
                    if (typeList != null && typeList.length > 0) {
                        for (let i = 0; i < typeList.length; i++) {
                            let typeVal = typeList[i];
                            for (let j = 0; j < servcTypes.length; j++) {
                                let item = servcTypes[j];
                                if (item.value == typeVal) {
                                    let queryItem = {};
                                    queryItem.value = item.value;
                                    queryItem.label = item.text;
                                    servcTypeList.push(queryItem);
                                }
                            }
                        }
                    }
                    self.updateQueryModelField("type", servcTypeList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                console.log(itemCode);
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            // 获取服务类型
            getServcTypeList: function (callbackFun) {
                let theLoad = MsgBox.loading();
                servcApi.getServcTypeList({}, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        callbackFun(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if (!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if (self.checkedIdsX.contains(id)) {
                    for (let i = 0; i < self.checkedList.length; i++) {
                        let checkedInfo = self.checkedList[i];
                        if (checkedInfo.ssuId == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                //
                if (self.checkedIniting) {
                    return;
                }
                //
                let allIds = this.ssuList.pluck("ssuId");
                let selIds = selRows.pluck("ssuId");
                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                //
                selIds.forEach(function (id, index) {
                    let selRow = selRows[index];
                    //
                    self.addCheckId(id, selRow);
                });
                //
                lesIds.forEach(function (id) {
                    //
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if (theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // ===================== 分页多选结束 ==============================
            queryHandler: function (queryModel) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                this.queryModel = queryModel;
                this.getSsuList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getSsuList();
            },
            getSsuList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.totalFlag = true;
                if (!Utils.isNoB(filterItems.srcMerchantType)) {
                    if (filterItems.srcMerchantType == 0) {
                        filterItems.srcMerchantType = null;
                        filterItems.authFlag = false;
                    } else {
                        filterItems.authFlag = true;
                    }
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                servcApi.getMsuPagedList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        self.ssuList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.ssuList, self.checkedTblRefId, 'ssuId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let result = {};
                result.type = "info";
                result.actionName = this.activeName;
                if (this.activeName == "setEngineerServc") {
                    //
                    result.data = this.checkedIdsX || [];
                } else {
                    if (this.servicerShopId == null) {
                        result = this.$refs.swb_servicer_xngineer_list_select.getDlgResult() || {};
                    } else {
                        result = this.$refs.swb_servicer_engineer_list_select.getDlgResult() || {};
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/EngineerSsuListForSelect.vue